<template>
    <el-select
            :placeholder="i18n.tkey('lang_area_text')"
            :size="null == size ? 'large' : size"
            :filterable="false"
            v-model="selectValue"
            @change="changeSelect"
            v-loading="loading"

    >

        <el-option

                v-for="item in countryList"
                :key="item.countrycode"
                :label="(userInfoRef.lang == 'zh' || userInfoRef.lang == 'szh') ? item.countryname : item.countryname2"
                :value="item.countrycode"
                :disabled="null != disabledValues && disabledValues.includes(item.countrycode)"
        />
    </el-select>
</template>

<script setup>
    import {inject, ref, onMounted, toRef, getCurrentInstance, onBeforeMount} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import countryApi from "@/request/countryApi";
    import myUtil from "@/util/util";

    const props = defineProps(['modelValue', 'disabledValues', 'useEmptyOption', 'size','classType'])
    const emits = defineEmits(['update:modelValue'])

    const userInfoRef = toRef(useUserinfo())

    const loading = ref(false)

    const i18n = inject("i18n")

    const selectValue = ref(null)
    const countryList = ref([])

    function getCountryList(){
        loading.value = true

        const request = countryApi.getCountryList
        const params = request.getParams()

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                countryList.value = res.detail

                if (props.useEmptyOption == true){
                    const emptyObj = {
                        countrycode: "all",
                        countryname: i18n.tkey("lang_all_region"),
                        countryname2: i18n.tkey("lang_all_region")
                    }

                    countryList.value.unshift(emptyObj)
                }
            }
        })

    }

    function changeSelect(value){
        emits("update:modelValue", value)
    }

    function getSelectObj(){
        let obj = {}

        for (let i=0; i<countryList.value.length; i++){
            const info = countryList.value[i]

            if (selectValue.value == info.countrycode){
                obj = info
                break
            }
        }

        return obj
    }

    defineExpose({
        getSelectObj
    })

    onBeforeMount(() => {
        selectValue.value = props.modelValue
        getCountryList()

    })

</script>

<style scoped>
.mselect .el-select{
  height: 50px;
  width: 100%;
  background-color: #90bfa9;

}
.mselect  .el-select /deep/ .el-input__inner {
  height: 50px;
  color: #FFFFFF;
}
.mselect .el-select /deep/ .el-input__suffix {
  top: 0;
  display: flex;
  align-items: center;
}
.mselect .el-select /deep/ .el-input__suffix-inner .el-icon{
  color: #FFFFFF;
}
.mselect .el-select /deep/ .el-input__wrapper{
  background-color: #90bfa9;
}


</style>